/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var popup_component_1 = require("./popup.component");
var kendo_angular_common_1 = require("@progress/kendo-angular-common");
var popup_service_1 = require("./popup.service");
var POPUP_DIRECTIVES = [popup_component_1.PopupComponent];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Popup component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Popup module
 * import { PopupModule } from '@progress/kendo-angular-popup';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, PopupModule], // import Popup module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
var PopupModule = /** @class */ (function () {
    function PopupModule() {
    }
    PopupModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [POPUP_DIRECTIVES],
            entryComponents: [POPUP_DIRECTIVES],
            exports: [POPUP_DIRECTIVES],
            imports: [common_1.CommonModule, kendo_angular_common_1.ResizeSensorModule],
            providers: [popup_service_1.PopupService]
        })
    ], PopupModule);
    return PopupModule;
}());
exports.PopupModule = PopupModule;
